/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ValueType, markStruct } from "igniteui-react-core";
/**
 * @hidden
 */
var Popup_InnerAnimationInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Popup_InnerAnimationInfo, _super);
    function Popup_InnerAnimationInfo() {
        var _this = _super.call(this) || this;
        _this.a = 0;
        _this.b = 0;
        return _this;
    }
    Popup_InnerAnimationInfo.$t = markStruct(Popup_InnerAnimationInfo, 'Popup_InnerAnimationInfo');
    return Popup_InnerAnimationInfo;
}(ValueType));
export { Popup_InnerAnimationInfo };
//# sourceMappingURL=Popup_InnerAnimationInfo.js.map
